import { render, staticRenderFns } from "./StepsInventario.vue?vue&type=template&id=18831268&scoped=true&"
import script from "./StepsInventario.vue?vue&type=script&lang=js&"
export * from "./StepsInventario.vue?vue&type=script&lang=js&"
import style1 from "./StepsInventario.vue?vue&type=style&index=1&id=18831268&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18831268",
  null
  
)

export default component.exports